import { render, staticRenderFns } from "./AsignaturaAgregar.vue?vue&type=template&id=7c922f08"
import script from "./AsignaturaAgregar.vue?vue&type=script&lang=js"
export * from "./AsignaturaAgregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports